export default {
	selectUnit: {
		txtTitle: 'Select your unit',
		txtNotification: 'Successfully assigned unit',
		txtAvailable: 'units available',
		txtEmpty: 'No units available'
	},
	global: {
		txtDelete: 'Delete',
		//email: "Email or phone number",
		email: "Email",
		emailRecover: "Email",
		password: "Password",
		rules: {
			passwordLength: "Minimum 8 characters",
			passwordRequired: "Password is required",
			emailRequired: "Required",
			emailValid: "E-mail must be valid",
			passwordNoMatch: "The password does not match",
		},
		snackbar: {
			close: "Close",
		},
		navigation: {
			txtServices: "Services",
			txtHistory: "History",
			txtChecking: "Check In",
		},
		dialog: {
			btnCancel: "Cancel",
			btnToAccept: "Continue",
			btnUpdate: "Update"
		},
		components: {
			services: {
				txtCalendar: "Services of the",
			},
			qrReader: {
				txtTitle: "Check in",
				txtInfo:
					"Please center the QR code to apply the passenger Check In.",
				txtServiceNoAsign:
					"The service you are looking for does not exist or has not been assigned.",
				txtErrorGeneric:
					"An error occurred when checking in the service.",
				txtInfoSelect: 'Select the type of check-in, preferably using QR.',
				txtOptions: 'Options',
				txtTitleCheckinM: 'Checkin Manual',
				txtDescM: 'A manual checkin will be applied, take into account that it is monitored at all times.'
			},
			listServices: {
				txtEmptyServices: "No services",
				txtSearch: "service ID"
			},
			empty: {
				txtEmptyData: "No data",
			},
			history: {
				txtCalendar: "History of",
			},
			noshow: {
				txtPhoto1: "Take a photo with the client's name sign at the meeting point.",
				txtPhoto2: 'Take a photo of your vehicle at the pickup location.',
				txtPhoto3: 'Take a photo of a printed format to support the No show (no show format, parking ticket, exit pass).'
			},
			offline: {
				txtTitle: 'Offline',
				txtOffline: 'Without connection'
			}
		},
		savedSuccessfully:"Successfully saved.",
		gpsRequiredAlert:"Location access is required to proceed. Please enable GPS permissions in your browser settings.",
		today:"Today"
	},
	login: {
		txtWelcome: "Welcome",
		txtSubtitle: "Enter your credentials",
		emailPlaceholder: "your@email.com",
		passwordPlaceholder: "Your password",
		forgotPassword: "Forgot your password?",
		btnLogin: "Sign In",
		btnInstallApp: "Install App",
		txtErrorRetrievingUserData: "Error retrieving user data",
		txtEmailPasswordInvalid: "Invalid email or password",
	},
	recover: {
		txtResetTitle: "New Password",
		txtResetSubtitle: "Enter your new password",
		updateTitle: "Change Password",
		updateSubtitle: "Enter your new password",
		newPassword: "New Password",
		newPasswordPlaceholder: "Minimum 8 characters",
		repeatPassword: "Confirm Password",
		repeatPasswordPlaceholder: "Repeat password",
		btnUpdatePassword: "Change Password",
		txtErrorUpdate: "An error occurred while updating the password.",
		txtSuccessUpdate: "Password updated successfully"
	},
	listChat: {
		txtTitle: "Messages",
		txtConversations: "conversations",
		today: "Today",
		noMessages: "No Messages",
	},
	home: {
		profile: "Profile",
		logout: "Sign off",
		waiting: "Wait a moment",
		txtHelpSupport: 'Help support',
		txtButtomUpdate: 'Check for update',
		txtSelectUnit: 'Select Unit',
		txtLicense: 'License',
		txtUnit: 'Unit',
		txtPlates: 'Plates'
	},
	forgot: {
		txtTitle: "Recover Password",
		txtSubtitle: "Enter your email to recover your password",
		emailPlaceholder: "your@email.com",
		btnReturnToLogin: "Return to Login",
		btnBackToLogin: "Back to login",
		btnSendEmail: "Send Email",
		txtEmaildSend: "A password recovery email was sent.",
		txTunexpectedError: "An unexpected error occurred",
	},
	chat: {
		newMessage: "New message",
		txtNoLoggetForChat: "no logged for chat",
		txtLocked: "Chat locked",
		txtLockedMessage: "Chat functionality has been disabled. This service is no longer in operation.",
		txtError: "Something went wrong",
		txtErrorMessage: "We couldn't load the chat. Please try again.",
		btnBack: "Go back",
		btnRetry: "Retry",
	},
	booking: {
		pickupOn: "Pickup On",
		at: "at",
		dropoffAt: "Dropoff at",
		flight: "Flight",
		flightNumber: "Flight Number",
		fligthTime: "Fligth Time",
		notes: "Notes",
		txtErrorServiceInProcess: "You already have another service in process",
		txtErrorNoMatchQr: "The current service does not match the QR.",
		txtErrorNoShow: "It will notify that it did not find the client.",
		txtError60Min: "60 minutes have not passed yet",
		txtError15Min: "Not yet 15 minutes",
		txtErrorNoTrip: "Trip type is not recognized",
		txtNoShowNotAllowed: "No Show not allowed",
		txtNoShowPlus: "to indicate a no show.",
		txtErrorChangeStatus: "There was a problem when changing the state",
		txtChangeStatus: "Status change",
		dialog: {
			btnCancel: "Cancel",
			btnToAccept: "Continue",
		},
		bookingStatusOpts: {
			txtActive: "Active",
			txtNoShow: "No Show",
			txtNoProvided: "Not attended",
			txtCanceled: "Cancelled",
			txtDone: "Done",
		},
		steps: {
			pending: {
				btnText: "",
				txtLabel: "pending",
				txtChangeStatusAlert: "The service is pending",
			},
			onWayToPickup: {
				btnText: "Start trip to the Origin",
				txtLabel: "Heading to $pickup",
				txtChangeStatusAlert: "Start trip to get to $pickup",
			},
			atPickup: {
				btnText: "I have arrived at the Origin",
				txtLabel: "In Origin for Pickup",
				txtChangeStatusAlert:
					"It will notify you that you have reached $pickup",
			},
			onWayToDropoff: {
				btnText: "Start trip to Destination",
				txtLabel: "Heading to Destination",
				txtChangeStatusAlert: "Start trip to get to $dropoff",
			},
			finished: {
				btnText: "End of service",
				txtLabel: "Service ended",
				txtChangeStatusAlert:
					"It will notify you that you have performed the service successfully",
			},
		},
		txtErrorCord: 'The service coordinates are not correct.',
		txtErrorDistance: 'Not yet within a 5 KM radius.',
		txtGpsError: 'GPS deactivated, please activate it.'
	},
	profile: {
		txtFirstName: "First Name",
		txtLastName: "Last Name",
		txtEmail: "Email",
		txtLicenseNumber: "License Number",
		txtTypeUser: "Type User",
		txtLanguaje: "Language",
		txtPersonalInfo: "Personal Information",
		txtSettings: "Settings",
		txtLanguageHint: "App language",
		btnSave: "Save",
	},
	update: {
		txtTitle: 'Updating Version',
		txtUpdate: 'A new version was downloaded, please reload the app.',
		btnReload: 'Reload app'
	},
	noShow: {
		txtTitle: 'No Show Evidence',
		txtSubtitle: 'Document the No Show evidence',
		txtInstructions: 'Instructions',
		txtPhotos: 'Photos',
		txtNoPhotos: 'No photos added',
		txtMinPhotos: 'Minimum 3 photos required',
		takePhoto: 'Take photo',
		uploadImages: 'Upload images',
		notesPlaceholder: 'Add additional notes (optional)',
		btnSubmit: 'Report No Show',
		txtUploading: 'Uploading evidence in background...',
		txtUploadSuccess: 'No Show reported successfully',
		txtUploadError: 'Error reporting No Show, please try again',
		txtAlertSuccessTitle: 'Report Sent',
		txtAlertErrorTitle: 'Report Error',
	},
	qrReader: {
		manualDesc: "Manual check-in",
		qrDesc: "Scan code",
		initializing: "Initializing camera...",
	},
	lblTrackingStatus: {
		pending: "Ready to go",
		onWayToPickup: "Heading to meet point",
		atPickup: "You arrived at meet point",
		onWayToDropoff: "Driving passenger",
		finished: "Service completed",
	},
	flightStatus: {
		on_time: "On time",
		landed: "Landed",
		delayed: "Delayed",
		cancelled: "Cancelled",
		early: "Early",
		unknown: "Unknown",
		delayedMinutes: "Delayed {minutes} min",
		earlyMinutes: "Early {minutes} min",
	},
	flightModal: {
		title: "Flight Information",
		origin: "Origin",
		route: "Route",
		status: "Status",
		progress: "Flight progress",
		scheduledTime: "Scheduled time",
		originalTime: "Scheduled flight time",
		estimatedLanding: "Current est. landing",
		estimatedGate: "Current gate arrival",
		actualLanding: "Actual landing",
		actualGate: "Actual gate arrival",
		terminal: "Terminal",
		gate: "Gate",
		landed: "Landed",
		inFlight: "In flight",
		notDeparted: "Not departed",
		viewOnFlightStats: "View on FlightStats",
		na: "N/A",
		dataSource: "Data source",
		lastUpdate: "Last update",
		noDataAvailable: "Flight data not found",
		noDataDescription: "Flight information is not available at this time. Please try again later.",
		flightUpdated: "Flight status has been updated",
	}
};
